<div
  class="d-flex align-items-center justify-content-center"
  [ngClass]="
    serviceOperator ? 'unicorn-quota-service-outer' : 'unicorn-quota-outer'
  "
>
  <div
    class="py-2 impossible-quotas d-flex align-items-center justify-content-center flex-wrap"
  >
    <div class="impossible-quotas-content d-flex">
      <i
        class="fa fa-exclamation-circle error-icon me-2"
        aria-hidden="true"
      ></i>
      <span *ngIf="unicornQuotas.length === 1"
        >{{ getCombinationOfqualification(unicornQuotas[0].criteria) }} has been
        flagged as a highly challenging quota. Please consider adjusting quotas
        or targeting to broaden your search.</span
      >
      <span *ngIf="unicornQuotas.length > 1">
        {{ unicornQuotas.length }} red quotas have been flagged as highly
        challenging. Please consider adjusting quotas or targeting to broaden
        your search.
      </span>
      <button
        class="btn text-center bg-light review-conflict-btn fw-bold"
        (click)="openReviewConflictModal()"
      >
        See improbable Quota(s)
      </button>
    </div>
    <div
      class="flex-item w-100 align-items-center justify-content-center aida-message"
      *ngIf="isAidaEnabled"
    >
      <ps-ui-aida-enabled-tooltip
        [isAidaEnabled]="isAidaEnabled"
        [direction]="'right'"
      ></ps-ui-aida-enabled-tooltip>
      <strong
        >Currently this survey does not qualify for AIDA&#8482; due to the
        detected difficulty of this survey's quotas</strong
      >
    </div>
  </div>
</div>
